var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.99902 14.791C11.7496 14.791 14.79 11.7506 14.79 8C14.79 4.24942 11.7496 1.20898 7.99902 1.20898C4.24845 1.20898 1.20801 4.24942 1.20801 8C1.20801 11.7506 4.24845 14.791 7.99902 14.791Z","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M16.6961 16.6959L13.249 13.2488","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

Search.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Search;

Search.default = Search;
